module.exports = __webpack_public_path__ + "img/logo-dark.5468595e.png";